import React from 'react';
import { useTranslations } from 'next-intl';
import styles from './LeaderboardEmptyState.module.css';

export const LeaderboardEmptyState: React.FC = () => {
  const t = useTranslations('performance-lab');

  return (
    <div
      className={styles.emptyCard}
      role="status"
      aria-label={t('leaderboard.empty.aria')}
    >
      <p className={styles.title}>{t('leaderboard.empty.title')}</p>
      <p className={styles.message}>
        {t('leaderboard.empty.message')}
      </p>
    </div>
  );
};
